import axios from '../utils/axiosConfig';

const communityAPI = {
  // =================== POSTS ===================
  createPost: async (data) => {
    const response = await axios.post('/community/posts', data);
    return response.data;
  },

  getFeed: async (params = {}) => {
    const response = await axios.get('/community/posts/feed', { params });
    return response.data;
  },

  getPost: async (postId) => {
    const response = await axios.get(`/community/posts/${postId}`);
    return response.data;
  },

  updatePost: async (postId, data) => {
    const response = await axios.put(`/community/posts/${postId}`, data);
    return response.data;
  },

  deletePost: async (postId) => {
    const response = await axios.delete(`/community/posts/${postId}`);
    return response.data;
  },

  getUserPosts: async (userId, params = {}) => {
    const response = await axios.get(`/community/users/${userId}/posts`, { params });
    return response.data;
  },

  // =================== COMMENTS ===================
  createComment: async (postId, data) => {
    const response = await axios.post(`/community/posts/${postId}/comments`, data);
    return response.data;
  },

  getPostComments: async (postId, params = {}) => {
    const response = await axios.get(`/community/posts/${postId}/comments`, { params });
    return response.data;
  },

  updateComment: async (commentId, data) => {
    const response = await axios.put(`/community/comments/${commentId}`, data);
    return response.data;
  },

  deleteComment: async (commentId) => {
    const response = await axios.delete(`/community/comments/${commentId}`);
    return response.data;
  },

  // =================== LIKES ===================
  toggleLike: async (data) => {
    const response = await axios.post('/community/likes/toggle', data);
    return response.data;
  },

  // =================== FOLLOW ===================
  toggleFollow: async (data) => {
    const response = await axios.post('/community/follow/toggle', data);
    return response.data;
  },

  getFollowers: async (userId, params = {}) => {
    const response = await axios.get(`/community/users/${userId}/followers`, { params });
    return response.data;
  },

  getFollowing: async (userId, params = {}) => {
    const response = await axios.get(`/community/users/${userId}/following`, { params });
    return response.data;
  },

  checkFollowStatus: async (userId) => {
    const response = await axios.get(`/community/users/${userId}/follow-status`);
    return response.data;
  },

  getFollowSuggestions: async (params = {}) => {
    const response = await axios.get('/community/follow/suggestions', { params });
    return response.data;
  },

  getMutualFollows: async (userId) => {
    const response = await axios.get(`/community/users/${userId}/mutual-follows`);
    return response.data;
  },

  // =================== MESSAGES ===================
  // Updated message methods with business context support
  sendMessage: async (data) => {
    const response = await axios.post('/community/messages', {
      receiverId: data.receiverId,
      content: data.content,
      businessId: data.businessId,
      businessName: data.businessName,
      productId: data.productId,
      productName: data.productName,
      serviceId: data.serviceId,
      serviceTitle: data.serviceTitle,
      orderId: data.orderId,
      orderNumber: data.orderNumber
    });
    return response.data;
  },

  getConversations: async (params = {}) => {
    const response = await axios.get('/community/messages/conversations', { params });
    return response.data;
  },

  getMessages: async (userId, params = {}) => {
    const response = await axios.get(`/community/messages/${userId}`, { params });
    return response.data;
  },

  getUnreadMessageCount: async () => {
    const response = await axios.get('/community/messages/unread/count');
    return response.data;
  },

  archiveConversation: async (conversationId) => {
    const response = await axios.post(`/community/conversations/${conversationId}/archive`);
    return response.data;
  },

  blockConversation: async (conversationId) => {
    const response = await axios.post(`/community/conversations/${conversationId}/block`);
    return response.data;
  },

  deleteMessage: async (messageId) => {
    const response = await axios.delete(`/community/messages/${messageId}`);
    return response.data;
  },

  // =================== SEARCH ===================
  searchUsers: async (params = {}) => {
    const response = await axios.get('/community/search/users', { params });
    return response.data;
  },

  searchPosts: async (params = {}) => {
    const response = await axios.get('/community/search/posts', { params });
    return response.data;
  },

  // =================== STATS ===================
  getUserStats: async (userId) => {
    const response = await axios.get(`/community/users/${userId}/stats`);
    return response.data;
  },

  getMyStats: async () => {
    const response = await axios.get('/community/users/me/stats');
    return response.data;
  },

  getUserProfile: async (userId) => {
    const response = await axios.get(`/community/profile/${userId}`);
    return response.data;
  },

  createMentionNotification: async (data) => {
    const response = await axios.post('/notifications/mentions', data);
    return response.data;
  },
};

export default communityAPI;